import LP_ABI from 'abis/lpToken.json'
import BigNumber from 'bignumber.js'
import { PAIR_ADDRESS } from 'constants/addresses'
import useRefresh from 'hooks/useRefresh'
import { useCallback, useEffect, useState } from 'react'
import { BIG_ONE, BIG_ZERO } from 'utils/bigNumber'
import multicall from 'utils/multicall'

/**
 * Gets all public data of Pool contract
 */
const useSwcPrice = (chainId: number): BigNumber => {
  const bnbPoolAddress = PAIR_ADDRESS[chainId]
  const { slowRefresh } = useRefresh()

  const [state, setState] = useState(BIG_ZERO)

  const fetchPriceData = useCallback(async () => {
    const userCalls = [
      {
        address: bnbPoolAddress,
        name: 'getReserves',
      },
    ]

    const [reserves] = await multicall(chainId, LP_ABI, userCalls)

    const reserve0 = new BigNumber(reserves[0].toString())
    const reserve1 = new BigNumber(reserves[1].toString())

    const price = BIG_ONE.times(reserve1).dividedBy(reserve0)

    setState(price)
  }, [chainId, bnbPoolAddress])

  useEffect(() => {
    fetchPriceData()
  }, [fetchPriceData, slowRefresh])

  return state
}

export default useSwcPrice
